import { defineMessages } from 'react-intl'

export default defineMessages({
  submit: {
    id: 'components.Button.submit',
    defaultMessage: 'SUBMIT',
    description: '提交',
  },
  pay: {
    id: 'components.Button.pay',
    defaultMessage: 'PAY',
    description: '支付',
  },
  add: {
    id: 'components.Button.add',
    defaultMessage: 'ADD',
    description: '添加',
  },
  confirm: {
    id: 'components.Button.confirm',
    defaultMessage: 'Confirm',
    description: '确认',
  },
  consentAgreementAndPay: {
    id: 'components.Button.consentAgreementAndPay',
    defaultMessage: 'CONSENT AGREEMENT AND PAY',
    description: '同意协议并支付',
  },
  done: {
    id: 'components.Button.done',
    defaultMessage: 'DONE',
    description: '完成',
  },
  tryAgain: {
    id: 'components.Button.tryAgain',
    defaultMessage: 'TRY AGAIN',
    description: '重试',
  },
  refresh: {
    id: 'components.Button.refresh',
    defaultMessage: 'REFRESH',
    description: '刷新',
  },
  finish: {
    id: 'components.Button.finish',
    defaultMessage: 'FINISH',
    description: '结束',
  },
  addBankAccount: {
    id: 'components.Button.addBankAccount',
    defaultMessage: 'Add bank account',
    description: '添加银行账户',
  },
  addNewCard: {
    id: 'components.Button.addNewCard',
    defaultMessage: 'Add bank card',
    description: '添加银行卡',
  },
  ok: {
    id: 'components.Button.ok',
    defaultMessage: 'OK',
    description: 'OK',
  },
  reset: {
    id: 'components.Button.reset',
    defaultMessage: 'RESET',
    description: '重置',
  },
  send: {
    id: 'components.Button.send',
    defaultMessage: 'Send',
    description: '发送',
  },
  resend: {
    id: 'components.Button.resend',
    defaultMessage: 'Resend',
    description: '重新发送',
  },
  cancel: {
    id: 'components.Button.cancel',
    defaultMessage: 'CANCEL',
    description: '取消',
  },
})
